import React from 'react'
import { useTranslation } from 'react-i18next'

import banner from 'resources/images/ourPeopleBanner.jpg'
import bgCn from 'resources/images/ourStrengthBgCn.jpg'
import bgEn from 'resources/images/ourStrengthBg.jpg'

export default function OurStrength() {
    const {
        t,
        i18n: { language },
    } = useTranslation()
    const list = [
        { title: 'ourStrength.why1', desc: 'ourStrength.why1Desc' },
        { title: 'ourStrength.why2', desc: 'ourStrength.why2Desc' },
        { title: 'ourStrength.why3', desc: 'ourStrength.why3Desc' },
        { title: 'ourStrength.why4', desc: 'ourStrength.why4Desc' },
    ]
    return (
        <div className='bg-white'>
            <div className='w-full aspect-[18/5]  max-h-[400px] relative'>
                <img src={banner} className='w-full h-full object-center object-cover' alt='' />
                <div className='absolute top-0 left-0 w-full h-full bg-[#00000080] opacity-60'></div>
                <h1 className='absolute z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#fff] text-[4.5vw] font-medium'>
                    {t('home.ourStrength')}
                </h1>
            </div>
            <div className='bg-container py-8 md:py-12 lg:py-15'>
                <div className='space-y-6'>
                    {list.map((item, index) => (
                        <div key={index} className='flex gap-5 pb-5 flex-col md:gap-8 md:items-center md:flex-row'>
                            <div className='rounded-2xl h-[50px] flex justify-center items-center font-bold text-2xl text-white bg-[#ba2025] w-full md:w-[324px]'>
                                {t(item.title)}
                            </div>
                            <div className='text-xl font-medium flex-1'>{t(item.desc)}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='w-full h-auto my-12'>
                <img
                    className='revealing-image w-full h-auto object-center object-cover'
                    src={language === 'en' ? bgEn : bgCn}
                    alt='our strength'
                    loading='lazy'
                />
            </div>
        </div>
    )
}
